// extracted by mini-css-extract-plugin
export default {"card":"MessageCard_card__qwtzt","date":"MessageCard_date__IzE9t","content-frame":"MessageCard_content-frame__Q7fPL"};